module.exports = __webpack_public_path__ + "static/media/AmericanPancakes2.c999f737.jpg";